import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import classes from './SummativeAssessment.module.css';
import SummativeAssessmentEdit from "./SummativeAssessmentEdit";
import SuccessProjectPopup from "../../../../../lms-shared/UI/Popups/SuccessProjectPopup/SuccessProjectPopup";
import SummativeAssessmentView from "./SummativeAssessmentView";
import { ScoreTypeEnum } from "../../../../../../models/ScoreTypeEnum"

const SummativeAssessment = ({
    dynamicIndicatorObj,
    submissionData,
    setSubmissionData,
    nextAssessment,
    markAssessmentAsChecked,
    editData,
    setEditData,
    handleNotification }) => {

    const { texts, direction, lang } = useSelector(state => state.translate);
    const [message, setMessage] = useState(null);
    const [feedback, setFeedback] = useState()

    useEffect(() => {
        if (submissionData && dynamicIndicatorObj) {

            let scoreAdditionalData;
            scoreAdditionalData = JSON.parse(submissionData?.scoreAdditionalData)
            let sharedWeight = calculateWeight(scoreAdditionalData, dynamicIndicatorObj)
            setFeedback({
                score: submissionData?.score ? submissionData.score : null,
                submissionStatusId: submissionData.submissionStatusId,
                remarks: submissionData?.remarks ? submissionData.remarks : null,
                scoreType: scoreAdditionalData?.ScoreType ? ScoreTypeEnum[scoreAdditionalData?.ScoreType] : ScoreTypeEnum.textScore,
                feedbackCriteria: dynamicIndicatorObj.scoreOptions.map(criterion => {
                    const criterionKey = criterion.criteria[lang];
                    const criterionValue = scoreAdditionalData ? scoreAdditionalData[criterionKey] : null
                    return {
                        criteria: { ...criterion.criteria },
                        jsonWeight: criterion.points,
                        weight: scoreAdditionalData ? !criterionValue && criterion.optional ? parseInt(criterion.points) : parseInt(criterion.points) + sharedWeight : parseInt(criterion.points),
                        optional: criterion.optional,
                        disable: scoreAdditionalData ? !criterionValue && criterion.optional ? true : false : false,
                        selectedAppreciationTextOption: scoreAdditionalData && ScoreTypeEnum[scoreAdditionalData.ScoreType] == ScoreTypeEnum.textScore ? criterionValue : null,
                        criteriaScoreForNumeric: criterionValue ? ScoreTypeEnum[scoreAdditionalData.ScoreType] == ScoreTypeEnum.numScore ? criterionValue : criterion.appreciationOption?.[criterionValue]?.points : null,
                        appreciationOptionForVerbal: { ...criterion.appreciationOption }
                    }
                })
            })
        }
    }, [submissionData, dynamicIndicatorObj])

    function calculateWeight(scoreAdditionalData, dynamicIndicatorObj) {
        let activeItems = []
        let inactiveItems = []
        if (scoreAdditionalData) // editing a checked submission
        {
            dynamicIndicatorObj.scoreOptions.map(criterion => {
                const criterionKey = criterion.criteria[lang];
                const criterionValue = scoreAdditionalData ? scoreAdditionalData[criterionKey] : null
                if (!criterionValue && criterion.optional)
                    inactiveItems.push(criterion)
                else
                    activeItems.push(criterion)
            })
            const sumWeghitToShare = inactiveItems?.reduce((sum, item) => sum + item.points, 0);
            const sharedWeight = sumWeghitToShare / activeItems.length;
            return sharedWeight
        }
        else {
            return 0
        }
    }
    const changeScoreType = (type) => {
        setMessage(<SuccessProjectPopup minHeight={"168px"} myHeight={"168px"} myWidth={'367px'} close={() => setMessage(null)} color="#CCF0F0" title={texts.Warn} type="Warn" cancelFunc={() => setMessage(null)}>
            <div className={classes.AlertContent}> {type == ScoreTypeEnum.numScore ? texts.errorChangeToNumericScoreType : texts.errorChangeToTextScoreType}</div>
            <div className={classes.Btns}>
                <button className={classes.CancelBtn} onClick={() => { cancel(null) }}>{texts.cancel}</button>
                <button className={classes.AlertBtn} onClick={() => { submit(type) }}>{texts.ok}</button>
            </div>
        </SuccessProjectPopup>)

        const cancel = () => {
            setMessage(null)
        }

        const submit = (type) => {
            setMessage(null)
            let newFeedbackCriteria = [...feedback.feedbackCriteria]
            newFeedbackCriteria.map(f => {
                f.criteriaScoreForNumeric = null
                f.selectedAppreciationTextOption=null
            })
            setFeedback(prevState => ({
                ...prevState,
                scoreType: type
            }))
        }
    }

    const changeSelectedAppreciationTextOption = (value, index) => {
        let newFeedbackCriteria = [...feedback.feedbackCriteria]
        newFeedbackCriteria[index] = {
            ...newFeedbackCriteria[index], selectedAppreciationTextOption: value, criteriaScoreForNumeric: newFeedbackCriteria[index].appreciationOptionForVerbal[parseInt(value)].points
        }
        setFeedback(prevState => ({
            ...prevState,
            feedbackCriteria: newFeedbackCriteria,
        }))
    }

    const changeFeedbackCriterionDisable = (index) => {
        let newFeedbackCriteria = [...feedback.feedbackCriteria]
        newFeedbackCriteria[index] = { ...newFeedbackCriteria[index], disable: !feedback.feedbackCriteria[index].disable, criteriaScoreForNumeric: null, selectedAppreciationTextOption: null }
        const activeItems = newFeedbackCriteria.filter(criterion => !criterion.disable);
        const inactivecriterions = newFeedbackCriteria.filter(criterion => criterion.disable);
        const sumWeghitToShare = inactivecriterions.reduce((sum, criterion) => sum + criterion.jsonWeight, 0);
        const weightToShare = sumWeghitToShare / activeItems.length
        newFeedbackCriteria.map(f => {
            f.weight = !f.disable ? f.jsonWeight + weightToShare : f.jsonWeight
        })
        setFeedback(prevState => ({
            ...prevState,
            feedbackCriteria: newFeedbackCriteria,

        }))
    }

    const changeCriteriaScoreForNumeric = (value, index) => {
        if (/^\d*$/.test(value) && value <= 100 && !feedback.feedbackCriteria[index].disable) {
            if (value == "") {
                let newFeedbackCriteria = [...feedback.feedbackCriteria]
                newFeedbackCriteria[index] = { ...newFeedbackCriteria[index], criteriaScoreForNumeric: null }
                setFeedback(prevState => ({
                    ...prevState,
                    feedbackCriteria: newFeedbackCriteria,
                }))
            }
            else {
                let newFeedbackCriteria = [...feedback.feedbackCriteria]
                newFeedbackCriteria[index] = { ...newFeedbackCriteria[index], criteriaScoreForNumeric: value }
                setFeedback(prevState => ({
                    ...prevState,
                    feedbackCriteria: newFeedbackCriteria,
                }))
            }
        }
    }

    const setRemarks = (remark) => {
        setFeedback(prevState => ({
            ...prevState,
            remarks: remark
        }))
    }

    return (
        <div className={`${classes[direction]} ${classes.SummativeAssessment}`}>
            {message}
            <div className={classes.ContainerOverflow}>
                {feedback &&
                    <div className={classes.Container}>
                        {editData ?
                            <SummativeAssessmentEdit
                                submissionData={submissionData}
                                setSubmissionData={setSubmissionData}
                                feedback={feedback}
                                setFeedback={setFeedback}
                                setMessage={setMessage}
                                setEditData={setEditData}
                                changeScoreType={changeScoreType}
                                changeSelectedAppreciationTextOption={changeSelectedAppreciationTextOption}
                                changeCriteriaScoreForNumeric={changeCriteriaScoreForNumeric}
                                changeFeedbackCriterionDisable={changeFeedbackCriterionDisable}
                                markAssessmentAsChecked={markAssessmentAsChecked}
                                setRemarks={setRemarks}
                                scoreAdditionalData={JSON.parse(submissionData.scoreAdditionalData)}
                                handleNotification={handleNotification}
                            >
                            </SummativeAssessmentEdit>
                            :
                            <SummativeAssessmentView
                                submissionData={submissionData}
                                remarks={feedback.remarks}
                                dynamicIndicatorObj={dynamicIndicatorObj}
                                setEditData={setEditData}
                                nextAssessment={nextAssessment}
                                title1={submissionData.submittedByUser.isGroup ? texts.feedbackSentToTeamStudent : texts.feedbackSentToStudent}
                                title2={feedback.scoreType == ScoreTypeEnum.numScore ? texts.numericFeedbackForTask : texts.verbalFeedbackForTask}
                                scoreAdditionalData={JSON.parse(submissionData.scoreAdditionalData)}
                            >
                            </SummativeAssessmentView>
                        }
                    </div>}
            </div>
        </div>
    )
}

export default SummativeAssessment;